import React, {useState} from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";

import BrushButton from "../_UI/brushButton";

import art from '../../theme/assets/redesign/hero.webp';
import usdtIcon from '../../theme/assets/redesign/wallet/token_usdt.svg';
import chevronIcon from '../../theme/assets/redesign/wallet/chevron_down.svg';
import qrIcon from '../../theme/assets/redesign/wallet/scan_qr.svg';
import brushWithdraw from '../../theme/assets/redesign/wallet/brush_withdraw.svg';
import {useDispatch, useSelector} from "react-redux";
import {
    setGoogleAuthenticatorModalStatus,
    withdraw,
    withdrawFailure,
    withdrawSuccess
} from "../../store/cabinet/action";
import {toast} from "react-toastify";

const CabinetWalletExchange = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const withdrawStatusErr = useSelector(store => store.cabinet.withdrawStatusErr);


    const [amount, setAmount] = useState('');
    const [wallet, setWallet] = useState('');

    const onChangeAmount = (e) => {
        let v = e.target.value;
        v = v.replace(/[^\d.,]/g, "");
        const p = v.indexOf(".") >= 0 ? v.indexOf(".") : v.indexOf(",");
        if (p >= 0) v = v.slice(0, p + 1) + v.slice(p + 1).replace(/[.,]/g, "");
        v = v.replace(/^(\d+[.,]?)(\d{0,2}).*$/, "$1$2");

        setAmount(v);
    };

    const clearHandler = () =>{
        setAmount('');
        setWallet('');
        dispatch(withdrawFailure(false));
        dispatch(withdrawSuccess(false));
    }

    const toastHandler = () => {
        dispatch(setGoogleAuthenticatorModalStatus({data: false, status: false, toastHandler: false}));
        toast(t('Ваша заявка на продажу успешно отправлена, ожидайте завершения транзакции!'));
        clearHandler();
    }



    const withdrawHandler = () =>{
        const otpHandler = () =>{
            dispatch(setGoogleAuthenticatorModalStatus({data: {amount: amount, wallet: wallet}, status: true, toastHandler: toastHandler}));
            delete withdrawStatusErr?.otp
            dispatch(withdrawFailure(withdrawStatusErr))
        }

        dispatch(withdraw({amount: amount, wallet: wallet}, toastHandler, otpHandler));
    }

    return (
        <section className={Styles.container}>
            <div className={Styles.art}>
                <img src={art} alt=""/>
            </div>
            <div className={Styles.title}>{t('Вывод')}</div>

            <div className={Styles.field}>
                <div className={`${Styles.input} ${withdrawStatusErr?.amount ? Styles.inputErr : ''}`}>
                    <input
                        type="text"
                        inputMode="decimal"
                        placeholder={t('Введите сумму')}
                        value={amount}
                        onChange={onChangeAmount}
                        onKeyDown={()=>{
                            if (withdrawStatusErr?.amount){
                                delete withdrawStatusErr?.amount;
                                dispatch(withdrawFailure(withdrawStatusErr));
                            }
                        }}
                    />
                    <div className={Styles.tokenSelect}>
                        <img src={usdtIcon} alt="" width="22" height="22"/>
                        <span>USDT</span>
                        <img src={chevronIcon} alt="" width="14" height="14"/>
                    </div>
                </div>
                {withdrawStatusErr?.amount ? <div className={Styles.errText}>{withdrawStatusErr.amount}</div> : null}
            </div>

            <div className={Styles.field}>
                <div className={`${Styles.input} ${withdrawStatusErr?.wallet ? Styles.inputErr : ''}`}>
                    <input
                        type="text"
                        placeholder={t('Введите адрес кошелька')}
                        value={wallet}
                        onChange={(e)=>{setWallet(e.target.value)}}
                        onKeyDown={()=>{
                            if (withdrawStatusErr?.wallet){
                                delete withdrawStatusErr?.wallet;
                                dispatch(withdrawFailure(withdrawStatusErr));
                            }
                        }}
                    />
                    <img className={Styles.qr} src={qrIcon} alt="" width="22" height="22"/>
                </div>
                {withdrawStatusErr?.wallet ? <div className={Styles.errText}>{withdrawStatusErr.wallet}</div> : null}
            </div>

            <BrushButton className={Styles.submit} variant="primary" brush={brushWithdraw} noArrow onClick={withdrawHandler}>{t('Вывести')}</BrushButton>
        </section>
    );
};

export default CabinetWalletExchange;
